import { VISIBLE_LEAGUES } from '@app/utils/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GamesStateI {
  games: any[];
  isLoading: boolean;
  error: string | null;
  // Pagination state
  currentPage: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  // Filter League
  currentLeague: string;
}

export const initialState: GamesStateI = {
  games: [],
  isLoading: false,
  error: null,
  // Pagination defaults
  currentPage: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  // Filter defaults
  currentLeague: VISIBLE_LEAGUES[0]
};

const gameSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {
    // Get Games
    getGames: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    getGamesByLeague: (state, action: PayloadAction<{ league: string; pageNumber?: number; limit?: number }>) => {
      state.isLoading = true;
      state.error = null;
    },
    getGamesSuccess: (
      state,
      action: PayloadAction<{
        games: any[];
        totalCount: number;
        pageNumber: number;
        limit: number;
        totalPages: number;
      }>
    ) => {
      state.games = action.payload.games;
      state.totalCount = action.payload.totalCount;
      state.currentPage = action.payload.pageNumber;
      state.pageSize = action.payload.limit;
      state.totalPages = action.payload.totalPages;
      state.isLoading = false;
      state.error = null;
    },
    getGamesFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Update game open market status
    updateGameOpenMarketStatus: (state, action: PayloadAction<{ gameId: string; enabled: boolean }>) => {
      state.isLoading = true;
      state.error = null;
    },
    updateGameOpenMarketStatusSuccess: (state, action: PayloadAction<{ gameId: string; enabled: boolean }>) => {
      const { gameId, enabled } = action.payload;
      const gameIndex = state.games.findIndex((game) => game._id === gameId);
      if (gameIndex !== -1) {
        state.games[gameIndex].openBettingEnabled = enabled;
      }
      state.isLoading = false;
      state.error = null;
    },
    updateGameOpenMarketStatusFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Set pagination params
    setPaginationParams: (state, action: PayloadAction<{ page: number; pageSize: number }>) => {
      state.currentPage = action.payload.page;
      state.pageSize = action.payload.pageSize;
    },

    // Set status filter
    setLeagueFilter: (state, action: PayloadAction<string>) => {
      state.currentLeague = action.payload;
      state.currentPage = 1; // Reset to first page when changing filter
    }
  }
});

export const {
  getGames,
  getGamesByLeague,
  getGamesSuccess,
  getGamesFailure,
  updateGameOpenMarketStatus,
  updateGameOpenMarketStatusSuccess,
  updateGameOpenMarketStatusFailure,
  clearError,
  setPaginationParams,
  setLeagueFilter
} = gameSlice.actions;

export default gameSlice.reducer;
